<template>
    <div class="episodes-list-order">
        <div class="episodes-featured-column">
            &nbsp;
        </div>
        <episodes-list-order-item
            v-for="(label, key) in orders"
            :key="key"
            v-model="order"
            :class="`episodes-${toKebabCase(key)}-column`"
            :by="key"
        >
            {{ label }}
        </episodes-list-order-item>
        <div class="episodes-actions-column">
            &nbsp;
        </div>
    </div>
</template>
<script>
import EpisodesListOrderItem from './EpisodesListOrderItem';
import { kebabCase } from 'lodash';

export default {
    components: {
        EpisodesListOrderItem,
    },

    model: {
        event: 'change',
        prop: 'value',
    },

    props: {
        show: {
            type: [Object, Boolean],
            default: () => ({}),
        },

        value: {
            type: Object,
            default: () => ({
                by: null,
                direction: null,
            }),
        },
    },

    /**
     * Data of the component.
     *
     * @returns {object} Data.
     */
    data() {
        return {
            orders: {
                title: 'Episode Title',
                season_episode: 'serial' === this.show.podcastType ? 'Season/Episode' : 'Episode',
                duration: 'Duration',
                total_listens: 'Listens',
            },
        };
    },

    computed: {
        order: {
            /**
             * Gets order value.
             *
             * @returns {object} Order value.
             */
            get() {
                return this.value;
            },

            /**
             * Sets order value.
             *
             * @param {object} value Order value.
             */
            set(value) {
                this.$emit('change', value);
            },
        },
    },

    methods: {
        /**
         * Converts value to kebab-case.
         *
         * @param   {string} value Value to transform
         * @returns {string}       Transformed value.
         */
        toKebabCase(value) {
            return kebabCase(value);
        },
    },
};
</script>
